import React from 'react';
import styled from 'styled-components';

const SoloContent = styled.div`
  max-width: ${(props) => props.theme.screenSizes.tablet}px;
`;

export default SoloContent;
